export default __webpack_public_path__ + "static/media/billing.36bafb88.png";